module.exports = __webpack_public_path__ + "img/on-line-dist.7737b3ec.svg";